module.exports = __webpack_public_path__ + "6b11b8c7ee0cdc1ffe9c1fa18991afd4.png";